import * as z from "zod";

import { StoreSchema, storeIdSchema } from "../shared/store";

export const getStore = {
  name: "getStore" as const,
  input: z.object({ storeId: storeIdSchema }),
  output: z.object({ store: StoreSchema }),
};
